<div class="analysis-main" *transloco="let t; prefix: 'fuelDashboard'">
  <div class="top-title">
    <h2>{{ t('modals.totalDecreaseBreakdown.title') }}</h2>
    <button type="button" (click)="closeModal()">
      <img src="assets/images-fuel/closeModalBtnIcon.svg" alt="icon-close" />
    </button>
  </div>
  <div class="inner-body">
    <div class="row-main">
      <div class="table-right">
        <div class="card">
          <h3>{{ t('modals.totalDecreaseBreakdown.tableTitle') }}</h3>
          <!-- <app-common-table [modalType]="'fuel-breakdown'"></app-common-table> -->
          <div class="main-table fuelcost-breakdown">
            <table class="table">
              <thead>
                <tr>
                  <th class="factor">{{ t('table.factor') }}</th>
                  <th class="last-month">
                    {{ t('table.lastMonth') }}<button class="filter-button">
                      <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                    </button>
                  </th>
                  <th class="this-month">
                    {{ t('table.thisMonth') }}<button class="filter-button">
                      <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                    </button>
                  </th>
                  <th class="change">
                    {{ t('table.change') }}<button class="filter-button">
                      <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.totalDecreaseBreakdown.totalVehicle') }}</p>
                  </td>
                  <td class="last-month">
                    <p>1000</p>
                  </td>
                  <td class="this-month">
                    <p>1000</p>
                  </td>
                  <td class="change">
                    <p>0%</p>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.totalDecreaseBreakdown.totalFuelCost') }}</p>
                  </td>
                  <td class="last-month">
                    <p>{{ t('values.rands', { value: '500 000' }) }}</p>
                  </td>
                  <td class="this-month">
                    <p>{{ t('values.rands', { value: '550 000' }) }}</p>
                  </td>
                  <td class="change">
                    <p>+5%</p>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.totalDecreaseBreakdown.fuelPurchased') }}</p>
                  </td>
                  <td class="last-month">
                    <p>{{ t('values.litres', { value: '60 000' }) }}</p>
                  </td>
                  <td class="this-month">
                    <p>{{ t('values.litres', { value: '78 000' }) }}</p>
                  </td>
                  <td class="change">
                    <p>+7%</p>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.totalDecreaseBreakdown.fuelPrice') }}</p>
                  </td>
                  <td class="last-month">
                    <p>{{ t('values.randsPerLitre', { value: '22' }) }}</p>
                  </td>
                  <td class="this-month">
                    <p>{{ t('values.randsPerLitre', { value: '25' }) }}</p>
                  </td>
                  <td class="change">
                    <p>+13.64%</p>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.totalDecreaseBreakdown.fuelLossCost') }}</p>
                  </td>
                  <td class="last-month">
                    <p>{{ t('values.rands', { value: '30 000' }) }}</p>
                  </td>
                  <td class="this-month">
                    <p>{{ t('values.rands', { value: '35 000' }) }}</p>
                  </td>
                  <td class="change">
                    <p>+50%</p>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.totalDecreaseBreakdown.idleFuelWastage') }}</p>
                  </td>
                  <td class="last-month">
                    <p>{{ t('values.rands', { value: '60 000' }) }}</p>
                  </td>
                  <td class="this-month">
                    <p>{{ t('values.rands', { value: '72 000' }) }}</p>
                  </td>
                  <td class="change">
                    <p>+20%</p>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.totalDecreaseBreakdown.avgRouteType') }}</p>
                  </td>
                  <td class="last-month">
                    <p>-</p>
                  </td>
                  <td class="this-month">
                    <p>-</p>
                  </td>
                  <td class="change">
                    <p>-</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="left-card">
        <div class="card grap-card increase">
          <div class="card-body p-0">
            <div class="grap-up d-flex align-items-center justify-content-between">
              <div class="graph-text">
                <h4>{{ t('widgets.totalDecrease') }}</h4>
                <p>
                  {{ t('values.litres', { value: '200' }) }} <strong>+19.29%</strong>
                  <img src="assets/images-fuel/greenArrowIcon.svg" alt="">
                </p>
              </div>
              <div class="button-wrapper">
                <div class="common-drop-down no-Filter dropdown">
                  <button type="button" id="dropdown-menu" data-bs-toggle="dropdown" aria-expanded="false">
                    <img src="assets/images-fuel/threeDotBtnIcon.svg" alt="graph-Icon" />
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdown-menu">
                    <li><a class="dropdown-item">{{ t('units.litres') }}</a></li>
                    <li>
                      <a class="dropdown-item">{{ t('units.litresPerKilometer') }}</a>
                    </li>
                    <li>
                      <a class="dropdown-item">{{ t('units.litresPer100km') }}</a>
                    </li>
                    <li>
                      <a class="dropdown-item">{{ t('units.randsPerLitre') }}</a>
                    </li>
                  </ul>
                </div>
                <button (click)="fullChartClick()" class="graph-button">
                  <img src="assets/images-fuel/grapBtnIcon.svg" alt="graph-Icon" />
                </button>
              </div>
            </div>
            <div class="graph-down">
              @defer (on timer(200ms)) {
              <app-grouped-bar-chart [data]="totalDecreaseData" [barWidth]="12" [chartHeight]="152"
                [exportBtn]="false" />
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
